import { radiusScale, stroke } from "./spacing";

/**
 * Semantic shape tokens. Mirrors Figma "Theme / Shape" variable collection,
 * Xsolla Default mode. Values alias into the radiusScale and stroke primitives.
 */
export const shape = {
  button: {
    xl: { borderRadius: radiusScale["100"], borderWidth: stroke["1"] },
    lg: { borderRadius: radiusScale["100"], borderWidth: stroke["1"] },
    md: { borderRadius: radiusScale["75"], borderWidth: stroke["1"] },
    sm: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
    xs: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
  },
  checkbox: {
    xl: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
    lg: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
    md: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
    sm: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
  },
  input: {
    xl: { borderRadius: radiusScale["100"], borderWidth: stroke["1"] },
    lg: { borderRadius: radiusScale["100"], borderWidth: stroke["1"] },
    md: { borderRadius: radiusScale["75"], borderWidth: stroke["1"] },
    sm: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
    xs: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
  },
  segmented: {
    xl: { borderRadius: radiusScale["100"], borderWidth: stroke["1"] },
    lg: { borderRadius: radiusScale["100"], borderWidth: stroke["1"] },
    md: { borderRadius: radiusScale["100"], borderWidth: stroke["1"] },
    sm: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
  },
  segmentedItem: {
    xl: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
    lg: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
    md: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
    sm: { borderRadius: radiusScale["25"], borderWidth: stroke["1"] },
  },
  switch: {
    xl: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
    lg: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
    md: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
    sm: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
  },
  knob: {
    xl: { borderRadius: radiusScale["25"] },
    lg: { borderRadius: radiusScale["25"] },
    md: { borderRadius: radiusScale["25"] },
    sm: { borderRadius: radiusScale["25"] },
  },
  tabItem: {
    xl: { borderRadius: radiusScale["100"] },
    lg: { borderRadius: radiusScale["100"] },
    md: { borderRadius: radiusScale["50"] },
    sm: { borderRadius: radiusScale["50"] },
  },
  tag: {
    xl: { borderRadius: radiusScale["100"], borderWidth: stroke["1"] },
    lg: { borderRadius: radiusScale["100"], borderWidth: stroke["1"] },
    md: { borderRadius: radiusScale["75"], borderWidth: stroke["1"] },
    sm: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
    xs: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
    label: { borderRadius: 0 },
  },
  tooltip: {
    xl: { borderRadius: radiusScale["100"] },
    lg: { borderRadius: radiusScale["100"] },
    md: { borderRadius: radiusScale["100"] },
    sm: { borderRadius: radiusScale["50"] },
  },
  radio: {
    xl: { borderRadius: radiusScale["999"], borderWidth: stroke["1"] },
    lg: { borderRadius: radiusScale["999"], borderWidth: stroke["1"] },
    md: { borderRadius: radiusScale["999"], borderWidth: stroke["1"] },
    sm: { borderRadius: radiusScale["999"], borderWidth: stroke["1"] },
  },
  contextMenu: {
    xl: { borderRadius: radiusScale["100"] },
    lg: { borderRadius: radiusScale["100"] },
    md: { borderRadius: radiusScale["100"] },
    sm: { borderRadius: radiusScale["50"] },
    xs: { borderRadius: radiusScale["50"] },
  },
  avatar: {
    xl: { borderRadius: radiusScale["100"], borderWidth: stroke["1"] },
    lg: { borderRadius: radiusScale["75"], borderWidth: stroke["1"] },
    md: { borderRadius: radiusScale["75"], borderWidth: stroke["1"] },
    sm: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
    xs: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
    xxs: { borderRadius: radiusScale["25"], borderWidth: stroke["1"] },
  },
  cell: {
    borderRadius: radiusScale["100"],
    borderWidth: stroke["1"],
  },
  modal: {
    borderRadius: radiusScale["100"],
  },
  toast: {
    borderRadius: radiusScale["50"],
  },
  toggleButtonGroup: {
    xl: { borderRadius: radiusScale["100"], borderWidth: stroke["1"] },
    lg: { borderRadius: radiusScale["100"], borderWidth: stroke["1"] },
    md: { borderRadius: radiusScale["75"], borderWidth: stroke["1"] },
    sm: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
    xs: { borderRadius: radiusScale["50"], borderWidth: stroke["1"] },
  },
  tagLabel: {
    borderRadius: 0,
  },
} as const;
